import Vue from 'vue'
import { RUN_USER_LOGIN,RUN_USER_LOGOUT,RUN_STATE_LOAD,GET_TOKEN,SET_STATE,SET_STATE_PERSIST_LOCAL,SET_TOGGLE_LOADER,SET_INFO,GET_USER, SAVE_FIREBASE_TOKEN} from '../types'
import * as types from '@/types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
import { Const } from '../plugins/fxView/provider/candle-history/lib/const.cls'


export const actions = {
  	[RUN_USER_LOGIN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADMIN_LOGIN, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				result.res_data.user.loggedIn = true
				let role_array = result.res_data.user.roles.split('&')
				result.res_data.user.roles = role_array
				
				commit(SET_STATE, result.res_data.user)
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)));

				let getpath = localStorage.getItem("lastPath");
				if(getpath){
					credentials.localParams.parameter.$router.replace(getpath);
				 }
				else{
				 	credentials.localParams.parameter.$router.replace('/dashboard');
				 }

				let permision_array = result.res_data.user.permissions.split(',')
				commit(Const.SET_PERMISSION_LIST, permision_array)
				
				//credentials.localParams.parameter.$router.replace('/dashboard'); 
				credentials.localParams.parameter.$notify({
					group: 'foo',
					type : 'success',
					text: 'login successfully',
					duration: 10000,
					closeOnClick : true
				});

			}else{
				credentials.localParams.parameter.message = result.res_data.msg || result.res_data
				credentials.localParams.parameter.message_type = 'error'
			}
		})
  	},
	[RUN_USER_LOGOUT]({commit, state, getters}, getdata) {
		RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_ADMIN_LOGOUT, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
		.map(response => response.data)
		.subscribe(data => {
				getdata.parameter.$root.$children[0].walletSessionTimeOut = false
				_handleLogout(data, commit, {router: getdata.router,parameter: getdata.parameter, forward:true})

			},
			(e, d, s) => {
				_handleLogout(e, commit, {router: getdata.router, forward:true})
			}

		)
	},
	[RUN_STATE_LOAD] ({commit, dispatch, state, getters}) {
		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user) 
			user = JSON.parse(user)
		}
		commit(SET_STATE, user)
		if(user !== null && user !==''){
			RxFactory.post(Enpoints.BASE_URL + "/get/fresh/user/data", {}  , {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							data.data.user.loggedIn = true
							let role_array = data.data.user.roles.split('&')
							data.data.user.roles = role_array
				
							commit(SET_STATE, data.data.user)
							localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
							
							let permision_array = data.data.user.permissions.split(',')
							commit(Const.SET_PERMISSION_LIST, permision_array)
						}
					}
				},
				e => {					
					_handleErrorResponse(e, commit)
				}
			)
		}
	},
	[SAVE_FIREBASE_TOKEN]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_SAVE_FIREBASE_TOKEN, credentials.globalParams , credentials.localParams,'',commit, (error, result)=>{
			if(!error){
				// console.log('firebase_token--',result.res_data)
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
}

//------------------------------------------------functions----------------------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}

function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			// window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}

function _handleLogout (data, commit,options,getters) {
	const router = options.router
	let user = {
		active: 0,
		country: '',
		created: '',
		email: '',
		profile: {
			firstname: '',
			lastname: '',
			pid: '',
			cid: ''
		},
		roles: '',
		token: false,
		username: '',
		loggedIn: false
	}
	
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	//localStorage.clear()
	localStorage.removeItem("user");
	localStorage.clear();
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		options.parameter.$notify({
			group: 'foo',
			type : 'success',
			text: 'logout successfully',
			duration: 10000,
			closeOnClick : true
		});
		window.location.replace("/");
	}
}

function _executeApi (apiLink, globalParams, localParams,commit, callback) {
	try{
		let response_array = [],  headersJson = {};
		localParams.parameter.pageLoader = true
 		RxFactory.post(Enpoints.BASE_URL + apiLink, globalParams, '')
		.map(response => response.data)
		.subscribe(data => 
		{	localParams.parameter.pageLoader = false
			if ('info' in data){
				if (data.info === 'OK') {
					response_array.res_data = data.data
					callback(false, response_array)
				}
				else{
					if('status' in data && data.status == 401){
                        _handleErrorResponse(data.errors, commit)
                    }else{
						response_array.res_data = data.msg
						callback(true, response_array)
					}
				}
			}
		},
		e => {	_handleErrorResponse(e, commit)	}) 
	}catch(ex){	_handleErrorResponse(ex, commit) }
}




// WEBPACK FOOTER //
// ./src/store/actions.js